import * as actionTypes from '../../../actions/customerSatisfactionSurvey/customerSatisfactionSubmitForm';
import { customersSatisfactionFieldTracking } from './customerSatisfactionSurvey';

export const customersSatisfactionTracking = (store, next, action) => {
    if (action.type === actionTypes.CUSTOMER_FEEDBACK_SET_VALUE ||
        action.type === actionTypes.CUSTOMER_QUERY_PARAMETER_SET_VALUE ||
        action.type === actionTypes.SUBMIT_CUSTOMER_FEEDBACK) {
            return customersSatisfactionFieldTracking(store, next, action);
        }
}